import { Component, ChangeDetectionStrategy, inject, input, output, OnInit } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { FormsModule } from "@angular/forms";
import { Store } from "@ngrx/store";
import { TranslateModule } from "@ngx-translate/core";

import { CheckboxModule, CheckboxChangeEvent } from "primeng/checkbox";
import { ScrollPanelModule } from "primeng/scrollpanel";

import { Comment } from "src/api-service";
import { RelativeTimePipe } from "src/app/shared/pipe/relative-time.pipe";
import { selectUserContext } from "src/app/store/user/user.selectors";

@Component({
    selector: "app-create-order-dialog-comments",
    templateUrl: "./create-order-dialog-comments.component.html",
    styleUrls: ["./create-order-dialog-comments.component.scss", "../create-order-dialog.component.scss"],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CheckboxModule,
        FormsModule,
        TranslateModule,
        ScrollPanelModule,
        RelativeTimePipe,
    ],
})
export class CreateOrderDialogCommentsComponent implements OnInit {

    // =========================================================================
    // INPUTS / OUTPUTS
    // =========================================================================
    public readonly comments = input<Comment[]>([]);
    public readonly setCommentsToInclude = output<boolean[]>();

    // =========================================================================
    // DEPENDENCY INJECTION
    // =========================================================================
    private readonly store = inject(Store);

    // =========================================================================
    // STORE SIGNALS
    // =========================================================================
    public readonly user = toSignal(this.store.select(selectUserContext));

    // =========================================================================
    // PUBLIC PROPERTIES
    // =========================================================================
    public includeComments: boolean[] = [];

    // =========================================================================
    // LIFECYCLE
    // =========================================================================
    public ngOnInit(): void {
        this.includeComments = Array(this.comments().length).fill(false);
    }

    // =========================================================================
    // PUBLIC METHODS
    // =========================================================================
    public onIncludeCommentChange(event: CheckboxChangeEvent, index: number): void {
        this.includeComments[index] = event.checked;
        this.setCommentsToInclude.emit(this.includeComments);
    }
}
